// Convert hex -> RGB
export const getLogoColorFilters = (color) => {
  return color == '#076698'
    ? ''
    : 'invert(100%) sepia(100%) saturate(0%) hue-rotate(275deg) brightness(104%) contrast(105%)'
}
export const getImageColorFilters = (color) => {
  if (color == '#056553')
    return 'invert(27%) sepia(86%) saturate(408%) hue-rotate(119deg) brightness(98%) contrast(101%)'
  if (color == '#8B16AE')
    return 'invert(15%) sepia(92%) saturate(4281%) hue-rotate(282deg) brightness(78%) contrast(97%)'
  if (color == '#E98D32')
    return 'invert(16%) sepia(64%) saturate(4456%) hue-rotate(280deg) brightness(90%) contrast(102%)'
  if (color == '#931013')
    return 'invert(9%) sepia(107%) saturate(7117%) hue-rotate(353deg) brightness(81%) contrast(93%)'
  return ''
}

const hexToRgb = (hex) => {
  const cleanHex = hex.replace(/^#/, '')
  const bigint = parseInt(cleanHex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255
  return { r, g, b }
}

const rgbToHex = (r, g, b) =>
  '#' +
  [r, g, b]
    .map((x) => {
      const hex = x.toString(16)
      return hex.length === 1 ? '0' + hex : hex
    })
    .join('')

// Lighten/darken 
export const adjustColor = (hex, percent) => {
  const { r, g, b } = hexToRgb(hex)
  const newR = Math.min(255, Math.max(0, r + (r * percent) / 100))
  const newG = Math.min(255, Math.max(0, g + (g * percent) / 100))
  const newB = Math.min(255, Math.max(0, b + (b * percent) / 100))
  return rgbToHex(Math.round(newR), Math.round(newG), Math.round(newB))
}

export const getVariants = (hex) => {
  if (!hex) return { light: null, dark: null }
  return {
    light: adjustColor(hex, 40),
    dark: adjustColor(hex, -30),
    extraDark: adjustColor(hex, -50),
    lighter: adjustColor(hex, 600),
  }
}
